import { FC, ChangeEvent } from 'react'
import styles from 'styles/components/label.module.scss'
import InputTextSuggest, {
  suggestInfo as suggestInfoType,
} from 'components/Form/InputTextSuggest'
import LightLabel from 'components/Label/LightLabel'

type Props = {
  labelName: string
  description: string
  line: number
  type: string
  size: string
  margin?: string
  value: string
  placeholder: string
  errorText?: string | null
  suggestType: string
  index?: number | null
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onInput?: () => void
  onSelect: (info: suggestInfo, index: number | null | undefined) => void
  readOnly?: boolean
  style?: React.CSSProperties
}

export type suggestInfo = suggestInfoType

const InputTextSuggestWithLightLabel: FC<Props> = (props) => {
  const {
    labelName,
    description,
    line,
    type,
    size,
    margin,
    value,
    placeholder,
    errorText,
    suggestType,
    index,
    onChange,
    onInput,
    onSelect,
    readOnly,
    style,
  } = props

  const labelFormContainerStyle = (() => {
    switch (margin) {
      case 'default':
        return styles.inputtext_suggest_light
      case 'none':
        return styles.inputtext_suggest_none
      default:
        return styles.inputtext_suggest_light
    }
  })()

  const className = `${labelFormContainerStyle}`

  return (
    <div>
      <LightLabel name={labelName} description={description} line={line} />
      <div className={className}>
        <InputTextSuggest
          required={false}
          type={type}
          size={size}
          value={value}
          placeholder={placeholder}
          errorText={errorText}
          suggestType={suggestType}
          index={index}
          onChange={(e) => (onChange ? onChange(e) : null)}
          onInput={onInput}
          onSelect={onSelect}
          readOnly={readOnly}
          style={style}
        />
      </div>
    </div>
  )
}

export default InputTextSuggestWithLightLabel
